import { HydratedMint } from '@packages/interfaces'

export function isNFTExtension(mint: HydratedMint, extension: string) {
  return mint.imageUrl.includes(extension)
}
